require('bootstrap/js/affix');
var $ = require('jquery');
var _ = require('underscore');
var Marionette = require('backbone.marionette');

/*
    OPTIONS:
    - offset: (Int) Pixels from top to apply affix at
    - offset: (Object)
        top: pixels from top to apply affix at
        bottom: pxiels form bottom to apply affix at
    ~ (offset option ignored if offsetSelector passed ) ~
    - offsetSelector: (String) Selector of element to affix at
    - offsetSelector: (Array) Array of 2 selector strings.
        First: selector of element to Top affix at
        Second: selector of element to Bottom affix at
*/

var Affix = Marionette.Behavior.extend({
    defaults: function() {
        return {
            offset: 10,
            target: this.view.$el,
        };
    },
    ui: {
        affix: '[data-spy="affix"]',
    },
    onShow: function() {
        var offset = this.getOption('offset');
        var offsetSelector = this.getOption('offsetSelector');

        if (offsetSelector) {
            if (_.isArray(offsetSelector) && offsetSelector.length == 2) {
                offset = {
                    top: this.view.$(offsetSelector[0]).offset().top,
                    bottom: $(document).height() - this.view.$(offsetSelector[1]).offset().top,
                };
            } else {
                offset = this.view.$(this.getOption('offsetSelector')).offset().top;
            }
        }

        this.ui.affix.affix({
            offset: offset,
            target: this.getOption('target'),
        });
    },
});

module.exports = Affix;
